import { useNavigate } from "react-router-dom";
import { ContactDetail, Telegram, Email } from "../components";
import { FaInstagram, FaPhone } from "react-icons/fa";

import { thirdColor } from "../constants/constants";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"; 
// import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { ArrowLeft } from "../components";

const ContactUs = () => {
  const navigate = useNavigate(); // Initialize useNavigate

  const svgStyle = {
    height: "1.5rem",
    width: "1.5rem",
    color: thirdColor,
  };

  return (
    <div className="w-full flex-col items-center justify-center">
      <div className={`min-h-[70vh]`}>
        <div
          style={{ backgroundColor: thirdColor}}
          className={`min-h-[50vh] top-0 w-full flex items-center justify-center bg-[${thirdColor}]`}
        >
          <div className="flex flex-col items-center space-y-4">
            {/* Back Arrow */}
            <div
              className="absolute top-4 left-4 cursor-pointer"
              onClick={() => navigate('/virtual-cards')} // Directly navigate to the '/virtual-cards' page
            >
              <ArrowLeft className="h-6 w-6 text-white" />
            </div>

            <div className={`text-white text-5xl font-bold `}>Contact Us</div>
            <div className="w-[90%] sm:w-[50%] text-center text-lg text-slate-700">
              {/* Have questions or ready to kickstart your digital journey? Reach
              out to YEHADIGITAL! We're here to assist you. Let's turn your
              ideas into digital reality together. */}
            </div>
          </div>
        </div>
        <div className="w-full flex justify-center">
          <div className="w-[90%] md:w-[60%] bg-white rounded-md border shadow-md -mt-32 p-10">
            <div className="flex flex-col space-y-4 justify-center">
              {/* Contact Details */}
            
              <ContactDetail
                title="Telegram"
                content={
                  <a
                    href="https://t.me/Ashcard"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-500"
                  >
                    @Ashcard
                  </a>
                }
                icon={<Telegram style={svgStyle} />}
              />
              <ContactDetail
        title="Instagram"
        content={
          <a
            href="https://www.instagram.com/Ashcard__"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-500"
          >
            @Ashcard__
          </a>
        }
        icon={<FaInstagram style={svgStyle} />}
      />

      {/* <ContactDetail
        title="Facebook"
        content={
          <a
            href="https://www.facebook.com/Ashcard"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-500"
          >
            Ash Card
          </a>
        }
        icon={<FaFacebook style={svgStyle} />}
      /> */}

      <ContactDetail
        title="Phone"
        content={
          <a href="tel:+251908080876" className="text-blue-500">
            +251908080876
          </a>
        }
        icon={<FaPhone style={svgStyle} />}
      />

<ContactDetail
  title="Email"
  content={
    <a
      href="mailto:Support@ashcard.com" // Replace with your actual email
      className="text-blue-500"
    >
      Support@ashcard.com
    </a>
  }
  icon={<Email style={svgStyle} />}
/>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
